export default "__VITE_ASSET__DJ86mlzj__"